// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Vrwf","footer":"ModalUpdate_footer__1xN-X"};